// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"2fcc1d9a","261":"205c5c05","331":"ad9b73a5","380":"97daab93","526":"906a7ef8","542":"96d588e4","595":"39168c01","638":"4c6766ee"}[chunkId] + ".chunk.js";
};